import React from "react";
// import ShowcaseButton from '../showcase-components/showcase-button';
import {
  XYPlot,
  XAxis,
  YAxis,
  VerticalGridLines,
  GradientDefs,
  HorizontalGridLines,
  VerticalBarSeries,
  Crosshair,
  Hint,
  VerticalBarSeriesCanvas,
  LabelSeries,
  makeWidthFlexible,
} from "react-vis";

import moment from "moment";

// const labelData = greenData.map((d, idx) => ({
//   x: d.x,
//   y: Math.max(greenData[idx].y, blueData[idx].y),
// }));

const toINR = (num) => {
  return "₹ " + parseInt(num).toLocaleString("en-IN");
};

const trimSet = (arr) => {
  if (arr?.length < 10) return arr;
  const X = parseInt(arr?.length / 10);
  return arr?.filter(function (v) {
    return moment(v).format("DD") == "01";
  });
};

export default class BarChart extends React.Component {
  state = {
    useCanvas: false,
    crosshairValues: [],
    value: false,
    animation: false,
  };

  static getDerivedStateFromProps(props) {
    const DATA = props.data.map((series) => {
      return series.map((elem) => {
        return { ...elem, x: new Date(elem.x * 1000) };
      });
    });
    return {
      DATA,
    };
  }
  _onMouseLeave = () => {
    this.setState({ crosshairValues: [], value: false });
    console.log("leave");
  };
  _onNearestX = (value, { index }) => {
    this.setState({ crosshairValues: this.state.DATA.map((d) => d[index]) });
    console.log("cross");
  };

  render() {
    const { useCanvas } = this.state;
    const content = useCanvas ? "TOGGLE TO SVG" : "TOGGLE TO CANVAS";
    const BarSeries = useCanvas ? VerticalBarSeriesCanvas : VerticalBarSeries;
    // console.log(this.state.DATA);
    const FlexibleXYPlot = makeWidthFlexible(XYPlot);
    return (
      <div style={{ width: "100%" }}>
        <FlexibleXYPlot
          xType="ordinal"
          margin={{ left: 100 }}
          height={300}
          xDistance={100}
        >
          <GradientDefs>
            <linearGradient id="HotGradient" x1="0" x2="0" y1="0" y2="1.5">
              <stop offset="0%" stopColor="#EA5455" stopOpacity={0.7} />
              {/* <stop offset="100%" stopColor="#EA5455" stopOpacity={0.01} /> */}
            </linearGradient>
          </GradientDefs>
          <GradientDefs>
            <linearGradient id="GreenGradient" x1="0" x2="0" y1="0" y2="1.5">
              <stop offset="0%" stopColor="#24ca7a" stopOpacity={0.7} />
              {/* <stop offset="100%" stopColor="#24ca7a" stopOpacity={0.01} /> */}
            </linearGradient>
          </GradientDefs>
          {/* <VerticalGridLines /> */}
          <HorizontalGridLines />
          <XAxis
            tickFormat={(v) => moment(v).format("MMM YY")}
            tickValues={trimSet(this.state.DATA[0]?.map((d) => d.x))}
          />
          <YAxis />
          <Crosshair values={this.state.crosshairValues}>
            <div className="label-wrapper">
              {this.props.items.map((item, index) => (
                <div key={index}>
                  <div className="label-title">{this.props.items[index]}</div>
                  <div className="label-value">
                    {this.state.crosshairValues[index] &&
                      parseInt(this.state.crosshairValues[index].y)}
                  </div>
                </div>
              ))}
            </div>
          </Crosshair>
          {/* {this.state.value ? (
            <Hint
              value={this.state.value}
              align={{ vertical: "top", horizontal: "right" }}
            >
              <div className="label-wrapper">
             <div className="label-title"> {this.state.value.name}</div>
            
            
                <div lassName="label-value"> {toINR(this.state.value.y)}</div>
              
              </div>
            </Hint>
          ) : null} */}
          <VerticalBarSeries
            barWidth={
              this.state.DATA[1].length < 5
                ? "0.3"
                : this.state.DATA[1].length > 5 && this.state.DATA[1].length < 9
                ? "0.6"
                : "1"
            }
            className="vertical-bar-series-example"
            data={this.state.DATA[1]}
            color={"url(#HotGradient)"}
            animation={false}
            // onValueMouseOut={(datapoint, { event }) => {
            //   console.log("Out");
            //   this.setState({ animation: false });
            // }}
            // onValueMouseOver={(datapoint, { event }) => {
            //   this.setState({
            //     animation: false,
            //     value: { x: datapoint.x, y: datapoint.y, name: "Credit" },
            //   });
            // }}
            onMouseLeave={() => {
              this.setState({ crosshairValues: [] });
              console.log("leave");
            }}
            onNearestX={(value, { index }) => {
              this.setState({
                crosshairValues: this.state.DATA.map((d) => d[index]),
              });
              // console.log("cross");
            }}
          />
          <VerticalBarSeries
            barWidth={
              this.state.DATA[1].length < 5
                ? "0.3"
                : this.state.DATA[1].length > 5 && this.state.DATA[1].length < 9
                ? "0.6"
                : "1"
            }
            data={this.state.DATA[0]}
            color={"url(#GreenGradient)"}
            animation={false}
            // onValueMouseOut={(datapoint, { event }) => {
            //   console.log("Out");
            //   this.setState({ animation: false });
            // }}
            // onMouseLeave={() => {
            //   console.log("Out");
            // }}
            onValueMouseOver={(datapoint, { event }) => {
              this.setState({
                animation: false,
                value: { x: datapoint.x, y: datapoint.y, name: "Credit" },
              });
            }}
          />
          {/* <LabelSeries data={labelData} getLabel={(d) => d.x} /> */}
        </FlexibleXYPlot>
      </div>
    );
  }
}
